import React from 'react';
import Section1_index from '../components/components-index/component-section1-index';
import Section2_index from '../components/components-index/component-section2-index';
import Section3_index from '../components/components-index/component-section3-index';
import Section4_index from '../components/components-index/component-section4-index';
import Mini_cart from '../components/component-mini-cart';

function Home() {
    return (
        <>
            <Section1_index />
            <Section2_index />
            <Section3_index />
            <Section4_index />
            <Mini_cart />
        </>
    );
}

export default Home;